/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';

    var ObjectModel = function() { //eslint-disable-line
    };

    ObjectModel.prototype.simplify = function() {
        return Object.assign({}, this);
    };

    return ObjectModel;
});



// WEBPACK FOOTER //
// ./model/objectModel.js